/**
 * Утилиты для форматирования значений (единый источник правды)
 */
/**
 * Форматирует числовое значение как цену в рублях
 * @param value - числовое значение или строка
 * @param options - locale, suffix (по умолчанию true), maximumFractionDigits (по умолчанию 0)
 * @returns строка вида "1 500 ₽" или "1 500" при suffix: false
 */
export function formatPrice(value, options = {}) {
    const { locale = 'ru-RU', suffix = true, maximumFractionDigits = 0 } = options;
    const num = typeof value === 'number' ? value : Number(value ?? 0);
    const formatted = num.toLocaleString(locale, { maximumFractionDigits });
    return suffix ? `${formatted} ₽` : formatted;
}
/** Суффикс количества товара: " ×6" при qty>1, "" при 1. Единый формат везде (карточки, статистика). */
export function formatProductQuantitySuffix(quantity) {
    const q = quantity ?? 1;
    return q > 1 ? ` ×${q}` : '';
}
/** Компактный формат для web-master schedule: «1ч 30м». */
export function formatDurationCompact(minutes) {
    if (minutes === undefined || minutes === null)
        return '';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0 && mins > 0)
        return `${hours}ч ${mins}м`;
    if (hours > 0)
        return `${hours}ч`;
    return `${mins}м`;
}
/** Локализованный формат длительности (web-booking и др.). */
export function formatDurationLocalized(minutes, locale = 'ru') {
    if (minutes === undefined || minutes === null)
        return '—';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const langUnits = {
        ru: { hour: 'ч', minute: 'мин' },
        en: { hour: 'h', minute: 'min' },
        uz: { hour: 'soat', minute: 'daq' },
        tg: { hour: 'соат', minute: 'дақ' },
        ky: { hour: 'саат', minute: 'мүн' },
        az: { hour: 'saat', minute: 'dəq' },
        hy: { hour: 'ժ', minute: 'ր' },
        kk: { hour: 'сағ', minute: 'мин' },
        hi: { hour: 'घं', minute: 'मि' },
        it: { hour: 'h', minute: 'min' },
        ro: { hour: 'h', minute: 'min' },
    };
    const units = langUnits[locale];
    if (hours > 0 && mins > 0)
        return `${hours} ${units.hour} ${mins} ${units.minute}`;
    if (hours > 0)
        return `${hours} ${units.hour}`;
    return `${mins} ${units.minute}`;
}
//# sourceMappingURL=formatters.js.map